import { buildQuery } from '../../utils/url';

export const QUERY_PARAM_FILTER = 'f';

export const buildUseCaseQuery = (useCase) => {
	if (typeof useCase === 'object' && useCase !== null) {
		return buildQuery(QUERY_PARAM_FILTER, useCase.slug);
	}

	return '';
};
